import Validation from "../../../utils/validation.utils";
import locale from "../../../localization";

export const initialState = {
  businessId: {
    name: "businessId",
    value: "",
    placeholder: "B0012",
    required: true,
    validations: [Validation.required(), Validation.minlength(5, "Please enter a minimum of 5 characters")],
    maxLength: 5,
    label: locale.businessId,
  },
  businessName: {
    name: "businessName",
    value: "",
    maxLength: 5,
    label: locale.businessName,
  },
  invoiceType: {
    name: "invoiceType",
    value: null,
    label: locale.invoiceType,
  },
  invoiceMonth: {
    name: "invoiceMonth",
    value: null,
    label: locale.month,
  },
  invoiceYear: {
    name: "invoiceYear",
    value: null,
    label: locale.year,
  },
  invoicePeriod: {
    name: "invoicePeriod",
    value: {
      startDate: null,
      endDate: null,
    },
    type: "date",
    label: "Invoice Period",
  },
};
